function CssLoad(urls) {
  return new Promise(resolve => {
    setTimeout(() => {

      urls.forEach((url) => {
        var myCSS = document.createElement( "link" );
        myCSS.rel = "stylesheet";
        myCSS.href = url;
        myCSS.media = 'print';
        myCSS.addEventListener('load', () => {
          myCSS.media = 'all';
        })
        // insert it at the end of the head in a legacy-friendly manner
        document.head.insertBefore( myCSS, document.head.childNodes[ document.head.childNodes.length - 1 ].nextSibling );
      });
      resolve('fin');

    }, 100);
  });
}

// 最初にテキストを非表示。フォントをロード終了後に表示状態に。
// function TextFirstLoad() {
//   const textList = document.querySelectorAll('.js-anim-first-text');
//   Array.from(textList).forEach(list => {
//     list.classList.remove('js-anim-first-text');
//   });
// }

window.addEventListener('load', async() => {
  await CssLoad([ tmp_path.temp_uri+'/font/font.css' ]);
});